import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import {
  AccessTime as AccessTimeIcon,
  AccountCircle as AccountCircleIcon,
  DoneAll as DoneAllIcon,
  ExitToApp as ExitToAppIcon,
  Menu as MenuIcon,
  Notifications as NotificationsIcon,
} from '@material-ui/icons';
import LogoImg from '../../assets/images/logo.png';
import styled from 'styled-components';
import {
  makeStyles,
  Box,
  Toolbar,
  AppBar,
  IconButton,
  Badge,
  Tooltip,
  Typography,
  Menu,
  MenuItem,
  ListItemIcon as _ListItemIcon,
  ListItemText,
  Chip,
} from '@material-ui/core';
import Pagination from '@mui/material/Pagination';
import { NavLink, useHistory } from 'react-router-dom';
import theme from '../theme';
import { useAuthContext } from '../../store/auth';
import { IF } from 'utils/IF';
import {
  fetchUnspecifiedTripDataRequest,
  fetchCheckUpDateRequest,
  fetchAllNotificationCountRequest,
} from '../../http/requests';
import { DriveEta as DriveEtaIcon } from '@material-ui/icons';
import { MuiModal } from '../../ui';
import { ChangeType } from './ChangeType';
import { swedenRoleAuth } from 'utils/swedishName';
import moment from 'moment-timezone';

const drawerWidth = 320;

const LogoWrapper = styled(Box)({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
});

const Logo = styled('img')({
  width: '250px',
  '@media (max-width: 768px)': {
    width: '174px',
  },
  cursor: 'pointer',
});

const NotificationItem = styled(Box)({
  width: '400px',
  whiteSpace: 'normal',
  display: 'block',
  padding: theme.spacing(1),
  position: 'relative',
});

const NotificationPaginationWrapper = styled(Box)({
  margin: '10px',
  display: 'flex',
  alignItems: 'center',
});

const ListItemIcon = styled(_ListItemIcon)({
  minWidth: '35px',
});

const useStyles = makeStyles((theme) => ({
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: drawerWidth,
  },
  hide: {
    display: 'none',
  },
}));

const NotificationTitle = styled(Typography)({
  fontWeight: 600,
});

const Time = styled(Typography)({
  marginTop: theme.spacing(2),
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  fontSize: '12px',
});

const TimeIcon = styled(AccessTimeIcon)({
  marginRight: theme.spacing(1),
  fontSize: '16px',
});

const Seen = styled(DoneAllIcon)({
  color: theme.palette.primary.main,
  position: 'absolute',
  right: 0,
  bottom: 10,
  fontSize: '16px',
});

export const Navbar = ({ open, handleDrawerOpen }) => {
  const classes = useStyles();

  const [notificationMenuAnchor, setNotificationMenuAnchor] = useState(null);
  const [accountMenuAnchor, setAccountMenuAnchor] = useState(null);
  const [unspecifiedTrips, setUnspecifiedTrips] = useState([]);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [selectedTripolog, setSelectedTripolog] = useState(-1);
  const [drivers, setDrivers] = useState([]);
  const [checkupNotification, setCheckupNotification] = useState([]);
  const [taxDateNotification, setTaxDateNotification] = useState([]);
  const [page, setPage] = useState(1);
  const [notificationPerPage] = useState(10);
  const [checkUpPage, setCheckUpPage] = useState(1);
  const [checkUpPerPage] = useState(10);
  const [taxDatePage, setTaxDatePage] = useState(1);
  const [taxDatePerPage] = useState(10);
  const [totalNotificationCount, setTotalNotificationCount] = useState(0);

  const { logout, user, role, isLoggedin } = useAuthContext();
  const history = useHistory();

  const indexOfLastNotification = page * notificationPerPage;
  const indexOfFirstNotification =
    indexOfLastNotification - notificationPerPage;
  const currentNotification = unspecifiedTrips.slice(
    indexOfFirstNotification,
    indexOfLastNotification
  );

  const indexOfLastCheckup = checkUpPage * checkUpPerPage;
  const indexOfFirstCheckup = indexOfLastCheckup - checkUpPerPage;
  const currentCheckup = checkupNotification.slice(
    indexOfFirstCheckup,
    indexOfLastCheckup
  );
  const indexOfLastTax = taxDatePage * taxDatePerPage;
  const indexOfFirstTax = indexOfLastTax - taxDatePerPage;
  const currentTax = taxDateNotification.slice(indexOfFirstTax, indexOfLastTax);

  const toggleModal = (id, row) => {
    setNoteModalOpen((prevState) => !prevState);
    setSelectedTripolog(row);
  };

  const handleNotificationMenuOpen = async (event) => {
    setNotificationMenuAnchor(event.currentTarget);

    try {
      const response = await fetchUnspecifiedTripDataRequest();
      setUnspecifiedTrips(response.data.triplog);
      setDrivers(response.data.drivers);
      const res = await fetchCheckUpDateRequest();
      setCheckupNotification(res.data.checkUpNotificationData);
      setTaxDateNotification(res.data.taxDateNotificationData);
    } catch (error) {
      //console.log(error);
    }
  };

  const handleNotificationMenuClose = () => {
    setNotificationMenuAnchor(null);
  };
  const handleScrollMenu = (event) => {};

  const handleAccountMenuOpen = (event) => {
    setAccountMenuAnchor(event.currentTarget);
  };

  const handleAccountMenuClose = () => {
    setAccountMenuAnchor(null);
  };

  const handleNavigateToAccount = () => {
    handleAccountMenuClose();
    history.push('/account');
  };

  const handleLogout = () => {
    handleAccountMenuClose();
    logout();
  };
  const handleClick = (e, row) => {
    toggleModal(row.id, row);
  };
  const handleChangeTripType = ({ note, tripType, id }) => {
    toggleModal();
  };
  const handleUpdatedTrip = async () => {
    try {
      const response = await fetchUnspecifiedTripDataRequest();

      setUnspecifiedTrips(response.data.triplog);
    } catch (error) {
      console.log(error);
    }
  };

  let interval;
  const fetchCountData = async () => {
    interval = setInterval(async () => {
      try {
        const response = await fetchAllNotificationCountRequest();

        setTotalNotificationCount(response.data.totalNotificationCount);
      } catch (error) {}
    }, 15000);
  };

  useEffect(() => {
    if (isLoggedin) {
      fetchCountData();
    }
    return () => clearInterval(interval);
  }, [fetchAllNotificationCountRequest, isLoggedin]);

  const getDriverName = (driver_id) => {
    let driver = drivers.filter((item) => item.id === driver_id);
    let copy = { ...driver[0] };

    return copy;
  };

  const notificationCount = totalNotificationCount;

  const isNotificationMenuOpen = Boolean(notificationMenuAnchor);
  const isAccountMenuOpen = Boolean(accountMenuAnchor);

  const notificationMenuId = 'primary-notification-menu';
  const accountMenuId = 'primary-account-menu';
  const renderNotificationMenu = (
    <>
      {' '}
      <Menu
        anchorEl={notificationMenuAnchor}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        id={notificationMenuId}
        open={isNotificationMenuOpen}
        onClose={handleNotificationMenuClose}
        onScrollCapture={handleScrollMenu}
        getContentAnchorEl={null}
      >
        {notificationCount > 0 && (
          <NotificationPaginationWrapper>
            <Box>
              {' '}
              <Pagination
                count={Math.ceil(notificationCount / 10)}
                variant="outlined"
                onChange={(event, value) => {
                  setPage(value);
                  setCheckUpPage(value);
                  setTaxDatePage(value);
                }}
              />
            </Box>
          </NotificationPaginationWrapper>
        )}
        {currentCheckup?.map((row, index) => {
          return (
            <MenuItem key={index}>
              <NotificationItem>
                {/* Checkup Date near for replaced with Kontrolldatum nära för*/}
                <NotificationTitle variant="body1" color="primary">
                  Kontrolldatum nära för {row.name} {row.lastname}
                </NotificationTitle>
                {/* Checkup Due Date replaced with Förfallodatum för kontroll */}
                <Typography variant="body2">
                  Förfallodatum för kontroll :{' '}
                  {moment(row.vehicle.checkupDate).format('YYYY-MM-DD')}
                </Typography>
                {/* Checkup Location replaced with Kontrollplats */}
                <Typography variant="body2">
                  Kontrollplats : {row.vehicle.checkupLocation}
                </Typography>
                <Time variant="body2" color="primary">
                  <TimeIcon />{' '}
                  {moment(row.createdAt).format('YYYY-MM-DD hh:mm')}
                </Time>
                <Seen />
              </NotificationItem>
            </MenuItem>
          );
        })}
        {currentTax?.map((row, index) => {
          return (
            <MenuItem key={index}>
              <NotificationItem>
                {/* Tax Date near for replaced with Skattedatum nära för */}
                <NotificationTitle variant="body1" color="primary">
                  Skattedatum nära för {row.name} {row.lastname}
                </NotificationTitle>
                {/* Tax Due Date replaced with Skatteförfallodag */}
                <Typography variant="body2">
                  Skatteförfallodag :{' '}
                  {moment(row.vehicle.taxDate).format('YYYY-MM-DD')}
                </Typography>
                {/* Tax replaced with Beskatta */}
                <Typography variant="body2">
                  Beskatta : {row.vehicle.tax}
                </Typography>
                <Time variant="body2" color="primary">
                  <TimeIcon />{' '}
                  {moment(row.createdAt).format('YYYY-MM-DD hh:mm')}
                </Time>
                <Seen />
              </NotificationItem>
            </MenuItem>
          );
        })}
        {currentNotification?.map((row, index) => {
          return (
            <MenuItem key={index}>
              <NotificationItem onClick={(event) => handleClick(event, row)}>
                {/* Unpecified Trip of replaced with Ospecificerad resa av */}
                <NotificationTitle variant="body1" color="primary">
                  Ospecificerad resa av {getDriverName(row.driver_id).name}{' '}
                  {getDriverName(row.driver_id).lastname}
                </NotificationTitle>
                {/* Trip Started At replaced with Resan började kl */}
                <Typography variant="body2">
                  Resan började kl:{' '}
                  {moment(row.startTime).format('YYYY-MM-DD HH:mm:ss')}
                </Typography>
                {/* Trip Ended At  replaced with Resan slutade kl */}
                <Typography variant="body2">
                  Resan slutade kl:{' '}
                  {moment(row.endTime).format('YYYY-MM-DD HH:mm:ss')}
                </Typography>
                <Time variant="body2" color="primary">
                  <TimeIcon />{' '}
                  {moment(row.createdAt).format('YYYY-MM-DD [KL:] HH:mm')}
                </Time>
                <Seen />
              </NotificationItem>
            </MenuItem>
          );
        })}
        {!notificationCount > 0 && (
          <MenuItem>
            <NotificationItem>
              {/* <NotificationTitle variant="body1" color="primary">
              No New Notifications
            </NotificationTitle> */}
              {/* No New Notifications replaced with Inga nya aviseringar */}
              <Typography variant="body2">Inga nya aviseringar</Typography>
              {/* <Time variant="body2" color="primary">
              <TimeIcon /> {moment(row.createdAt).format('YYYY HH:MM')}
            </Time>
            <Seen /> */}
            </NotificationItem>
          </MenuItem>
        )}

        <MuiModal
          open={noteModalOpen}
          onClose={toggleModal}
          width={'600px'}
          title={{
            label: 'Vänligen ändra typ av resa', //Please Change the type of trip replaced with Vänligen ändra typ av resa
            icon: <DriveEtaIcon color="primary" />,
          }}
        >
          <ChangeType
            selectedTripolog={selectedTripolog}
            handleChangeTripType={handleChangeTripType}
            handleUpdatedTrip={handleUpdatedTrip}
            onClose={toggleModal}
          />
        </MuiModal>
      </Menu>
    </>
  );
  const renderAccountMenu = (
    <Menu
      anchorEl={accountMenuAnchor}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={accountMenuId}
      open={isAccountMenuOpen}
      onClose={handleAccountMenuClose}
      getContentAnchorEl={null}
    >
      <MenuItem onClick={handleNavigateToAccount}>
        <ListItemIcon>
          <AccountCircleIcon />
        </ListItemIcon>
        <ListItemText
          primary={
            <>
              <Typography variant="body2" gutterBottom>
                {user?.name} {user?.lastname}
              </Typography>
              <Typography variant="body2" gutterBottom>
                {user?.email}
              </Typography>
              <Chip label={swedenRoleAuth(role)} color="primary" size="small" />
            </>
          }
        />
      </MenuItem>
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <ExitToAppIcon />
        </ListItemIcon>
        {/* LogOut Name Is for Replaced Logga ut */}
        <ListItemText primary="Logga ut" />
      </MenuItem>
    </Menu>
  );

  return (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: open,
      })}
    >
      <Toolbar>
        <LogoWrapper>
          <NavLink to={isLoggedin === true ? '/' : '/login'}>
            {' '}
            <Logo src={LogoImg} alt="Trackmondo" />
          </NavLink>
        </LogoWrapper>
        <IF condition={isLoggedin}>
          <IconButton
            aria-label="show 17 new notifications"
            color="inherit"
            aria-controls={notificationMenuId}
            onClick={handleNotificationMenuOpen}
          >
            <Badge
              badgeContent={notificationCount > 0 ? notificationCount : 0}
              color="primary"
            >
              {/* Notifications replaced with Notifikationer */}
              <Tooltip title="Notifikationer">
                <NotificationsIcon />
              </Tooltip>
            </Badge>
          </IconButton>
          <IconButton
            aria-label="show 17 new notifications"
            color="inherit"
            aria-controls={accountMenuId}
            onClick={handleAccountMenuOpen}
          >
            {/* Account replaced with Konto */}
            <Tooltip title="Konto">
              <AccountCircleIcon />
            </Tooltip>
          </IconButton>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerOpen}
            className={clsx(open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
        </IF>
      </Toolbar>
      {renderNotificationMenu}
      {renderAccountMenu}
    </AppBar>
  );
};
